export default __webpack_public_path__ + "static/media/chargeCredit.34842b2d.mp3";